import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import testVertexShader from './shader/test/vertex.glsl'
import testFragmentShader from './shader/test/fragment.glsl'

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Sky Background - Chiroyli osmon
 */
const bgCanvas = document.createElement('canvas')
bgCanvas.width = 2
bgCanvas.height = 512
const bgContext = bgCanvas.getContext('2d')
const gradient = bgContext.createLinearGradient(0, 0, 0, 512)
gradient.addColorStop(0, '#0a1628')      // tepa - tungi ko'k
gradient.addColorStop(0.2, '#1a3a5c')    // qorong'i ko'k
gradient.addColorStop(0.4, '#4a90b8')    // o'rta ko'k
gradient.addColorStop(0.6, '#7ec8e3')    // yorqin ko'k
gradient.addColorStop(0.8, '#ffd89b')    // quyosh sariq
gradient.addColorStop(1, '#ff6b35')      // quyosh qizil
bgContext.fillStyle = gradient
bgContext.fillRect(0, 0, 2, 512)
const bgTexture = new THREE.CanvasTexture(bgCanvas)
scene.background = bgTexture

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const flagTexture = textureLoader.load('/textures/flag.jpg')

/**
 * Lights - Sunset yorug'lik
 */
// Quyosh yorug'ligi - iliq rang
const sunLight = new THREE.DirectionalLight('#ffaa55', 2.5)
sunLight.position.set(2, 1, 3)
scene.add(sunLight)

// Back light - ko'k tint
const backLight = new THREE.DirectionalLight('#4a90b8', 0.8)
backLight.position.set(-2, 2, -1)
scene.add(backLight)

// Osmon yorug'ligi (ambient)
const skyLight = new THREE.HemisphereLight('#7ec8e3', '#ff6b35', 0.5)
scene.add(skyLight)

/**
 * Flag mesh
 */
// Geometry - yuqori resolution
const geometry = new THREE.PlaneGeometry(1.8, 1.2, 150, 100)
const count = geometry.attributes.position.count
const randoms = new Float32Array(count)

for(let i = 0; i < count; i++)
{
    randoms[i] = Math.random()
}
geometry.setAttribute('aRandom', new THREE.BufferAttribute(randoms, 1))

// Material
const material = new THREE.ShaderMaterial({
    vertexShader: testVertexShader,
    fragmentShader: testFragmentShader,
    uniforms: {
        uFrequency: { value: new THREE.Vector2(5, 3) },
        uTime: { value: 0 },
        uColor: { value: new THREE.Color('cyan') },
        uTexture: { value: flagTexture },
        uLightPosition: { value: sunLight.position },
        uLightColor: { value: new THREE.Color('#fff5e6') },
        uAmbientLight: { value: new THREE.Color('#87CEEB') }
    },
    side: THREE.DoubleSide
})

gui.add(material.uniforms.uFrequency.value, 'x').min(0).max(20).step(0.01).name('frequencyX')
gui.add(material.uniforms.uFrequency.value, 'y').min(0).max(20).step(0.01).name('frequencyY')

// Mesh
const mesh = new THREE.Mesh(geometry, material)
mesh.scale.y = 2 / 3
mesh.position.set(0.25, 0.45, 0)
scene.add(mesh)

/**
 * Flag Pole (bayroq ustuni)
 */
const poleGeometry = new THREE.CylinderGeometry(0.015, 0.02, 2.5, 16)
const poleMaterial = new THREE.MeshStandardMaterial({
    color: '#8B7355',
    metalness: 0.3,
    roughness: 0.7
})
const pole = new THREE.Mesh(poleGeometry, poleMaterial)
pole.position.set(-0.65, 0.2, 0)
scene.add(pole)

// Pole top (tepa qismi)
const poleTopGeometry = new THREE.SphereGeometry(0.03, 16, 16)
const poleTopMaterial = new THREE.MeshStandardMaterial({
    color: '#C9A959',
    metalness: 0.8,
    roughness: 0.2
})
const poleTop = new THREE.Mesh(poleTopGeometry, poleTopMaterial)
poleTop.position.set(-0.65, 1.45, 0)
scene.add(poleTop)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0.192, 0.478, 2.500)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.dampingFactor = 0.05
controls.enablePan = false
controls.target.set(0.192, 0.476, 0)
controls.minAzimuthAngle = -Math.PI / 4
controls.maxAzimuthAngle = Math.PI / 4
controls.minPolarAngle = Math.PI / 3
controls.maxPolarAngle = Math.PI / 1.8
controls.minDistance = 1.5
controls.maxDistance = 4

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1.2

/**
 * Animate
 */
const clock = new THREE.Clock()
let animationId = null


const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update material
    material.uniforms.uTime.value = elapsedTime


    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    animationId = window.requestAnimationFrame(tick)
}

document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        if (animationId) {
            cancelAnimationFrame(animationId)
            animationId = null
        }
    } else {
        clock.start()
        tick()
    }
})

tick()
